import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _createSuper from "@babel/runtime/helpers/createSuper";
var _excluded = ["experiments"];

/**
 * This is a `smart` component. It will render the correct variant for the identified user.
 * To utilize, simply pass in the experiment ID as props, and pass the variant ID associated
 * with each child as props to that child. If no children match the variant, the first child given
 * will be used as the default.

  Example usage:
  <AB experimentID='my-cool-experiment'>
    <Categories variantName='Control' />
    <Categories variantName='blue' color='blue'/>
  </AB>
  */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import AB from './component';
import { activateExperiment, deactivateExperiment, eeeReported } from './actions';

var ABContainer = /*#__PURE__*/function (_Component) {
  _inherits(ABContainer, _Component);

  var _super = _createSuper(ABContainer);

  function ABContainer() {
    _classCallCheck(this, ABContainer);

    return _super.apply(this, arguments);
  }

  _createClass(ABContainer, [{
    key: "componentWillMount",
    value: // eslint-disable-next-line react/no-deprecated
    function componentWillMount() {
      // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration
      if (!this.props.experiments && process.env.NODE_ENV === 'development') {
        console.error('`experiments` reducer not found.' + 'Make sure to import the reducer and add to your redux store');
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          experiments = _this$props.experiments,
          props = _objectWithoutProperties(_this$props, _excluded);

      return /*#__PURE__*/React.createElement(AB, _extends({}, props, experiments));
    }
  }]);

  return ABContainer;
}(Component); // eslint-disable-next-line react/static-property-placement -- directive added automatically by Shepherd migration


ABContainer.displayName = 'AB Container'; // eslint-disable-next-line react/static-property-placement -- directive added automatically by Shepherd migration

ABContainer.propTypes = {
  // eslint-disable-next-line react/require-default-props -- directive added automatically by Shepherd migration
  experimentID: PropTypes.string,
  activateExperiment: PropTypes.func.isRequired,
  deactivateExperiment: PropTypes.func.isRequired,
  eeeReported: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired,
  experiments: PropTypes.shape({
    // eslint-disable-next-line react/forbid-prop-types -- directive added automatically by Shepherd migration
    availableExperiments: PropTypes.object,
    // eslint-disable-next-line react/forbid-prop-types -- directive added automatically by Shepherd migration
    currentlyActiveExperiments: PropTypes.object
  }).isRequired
};
export default connect(function (state, ownProps) {
  var active = state.experiments.currentlyActiveExperiments;
  return {
    experiments: state.experiments,
    hasBeenTracked: active && !!active[ownProps.experimentID]
  };
}, {
  activateExperiment: activateExperiment,
  deactivateExperiment: deactivateExperiment,
  eeeReported: eeeReported
})(ABContainer);